import { useParams, Link } from "react-router-dom";
import { articles, categories } from "@/mocks/articles";
import ArticleCard from "@/components/base/ArticleCard";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Breadcrumb, { getCategoryBreadcrumb } from "@/components/feature/Breadcrumb";

export default function Category() {
  const { slug } = useParams<{ slug: string }>();

  const currentCat = categories.find((c) => c.slug === slug);
  const catName = currentCat?.name || "全部";
  const catId = currentCat?.id || "all";

  const filteredArticles =
    catId === "all"
      ? [...articles].sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime())
      : articles
          .filter((a) => a.category === catId)
          .sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());

  const webPageSchema = {
    "@context": "https://schema.org",
    "@type": "CollectionPage",
    name: `51黑料 - ${catName}`,
    description: `51黑料吃瓜网${catName}专区，聚合最新${catName}相关黑料爆料与吃瓜内容，实时更新。`,
    url: `https://hzljbj.cn/category/${slug}`,
    mainEntity: {
      "@type": "ItemList",
      itemListElement: filteredArticles.slice(0, 10).map((article, index) => ({
        "@type": "ListItem",
        position: index + 1,
        url: `https://hzljbj.cn/article/${article.slug}`,
      })),
    },
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(webPageSchema)}</script>

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main className="pt-20 pb-8">
          <div className="w-full px-4 md:px-6">
            <Breadcrumb items={getCategoryBreadcrumb(slug || "all")} />

            <h1 className="mt-4 font-heading text-2xl md:text-3xl text-foreground-900">
              {catName}
              <span className="ml-3 text-base font-sans text-foreground-500 font-normal">
                共 {filteredArticles.length} 篇
              </span>
            </h1>

            {/* Sub category tabs */}
            <div className="mt-5 flex items-center gap-2 overflow-x-auto pb-2 flex-wrap">
              <Link
                to="/category/all"
                className={`px-4 py-1.5 rounded-full text-sm transition-all whitespace-nowrap ${
                  catId === "all"
                    ? "bg-primary-500 text-background-50"
                    : "bg-background-100 text-foreground-700 hover:bg-background-200"
                }`}
              >
                全部
              </Link>
              {categories.filter((c) => c.id !== "all").map((cat) => (
                <Link
                  key={cat.id}
                  to={`/category/${cat.slug}`}
                  className={`px-4 py-1.5 rounded-full text-sm transition-all whitespace-nowrap ${
                    catId === cat.id
                      ? "bg-primary-500 text-background-50"
                      : "bg-background-100 text-foreground-700 hover:bg-background-200"
                  }`}
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>

          {/* Articles Grid */}
          <section className="w-full px-4 md:px-6 mt-6">
            {filteredArticles.length > 0 ? (
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
                {filteredArticles.map((article) => {
                  const cat = categories.find((c) => c.id === article.category);
                  return (
                    <ArticleCard
                      key={article.id}
                      id={article.id}
                      title={article.title}
                      slug={article.slug}
                      excerpt={article.excerpt}
                      category={article.category}
                      categoryName={cat?.name || article.category}
                      date={article.date}
                      views={article.views}
                      image={article.image}
                    />
                  );
                })}
              </div>
            ) : (
              <div className="text-center py-20">
                <i className="ri-inbox-line text-5xl text-foreground-300" />
                <p className="mt-3 text-foreground-500">该分类暂无文章</p>
                <Link
                  to="/"
                  className="mt-4 inline-block px-5 py-2 bg-primary-500 text-background-50 rounded-full text-sm hover:bg-primary-600 transition-colors whitespace-nowrap"
                >
                  返回首页
                </Link>
              </div>
            )}
          </section>
        </main>

        <Footer />
      </div>
    </>
  );
}